module.exports = __webpack_public_path__ + "img/cover-popular-bg-mobile.36a570ab.jpg";